import { formatDuration, intervalToDuration } from 'date-fns';

/**
 * Returns a natural language interpretation of the time remaining.
 *
 * _NB: Will always return at least 1 second._
 *
 * @example
 * formatRemainingTime(0); // "1 second"
 * formatRemainingTime(1); // "1 second"
 * formatRemainingTime(60); // "1 minute"
 * formatRemainingTime(62); // "1 minute 2 seconds"
 *
 * @param remainingTimeInSeconds
 * @returns string
 */
export function formatRemainingTime(remainingTimeInSeconds: number) {
  const remainingMilliseconds = Math.max(1000, remainingTimeInSeconds * 1000);
  const interval = intervalToDuration({ start: 0, end: remainingMilliseconds });
  const formattedDuration = formatDuration(interval);
  return formattedDuration;
}
